import React from 'react';

const themeContext = React.createContext({
  theme: {},
});
// test
export default themeContext;
